import React, {Component} from 'react';
import TotalItem from "../voucher/component/TotalItem";

class SigortaTotalList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            value: "",
        }
    }

    render() {
        return (
            <div>
                <TotalItem label={"Toplam İptal Komisyonu Tutarı"}
                           disabled={true}
                           name="chargeTotalAmount"
                           value={this.props.data.chargeTotalAmount}
                           suffix={this.props.suffix}
                           size={{lSize:6,dSize:6}}/>
                <TotalItem label={"Toplam İstihsal Komisyonu Tutarı"}
                           disabled={true}
                           name="allowanceTotalAmount"
                           value={this.props.data.allowanceTotalAmount }
                           suffix={this.props.suffix}
                           size={{lSize:6,dSize:6}}/>

            </div>
        )
    }
}

export default SigortaTotalList;